module.exports = __webpack_public_path__ + "static/mindcop-fb2fd3208c329938384b89250e13ad1f.png";